import api from './api';

export const getLeaveVariations = (params) => api.get('/v1/leave-variations', { params });
export const getLeaveVariation = (id) => api.get(`/v1/leave-variations/${id}`);
export const createLeaveVariation = (data) => api.post('/v1/leave-variations', data);
export const updateLeaveVariation = (id, data) => api.put(`/v1/leave-variations/${id}`, data);
export const deleteLeaveVariation = (id) => api.delete(`/v1/leave-variations/${id}`);
// Hak ediş formu / rapor bağlantısı için kiracı bağlamı: ülke, Türkiye kilidi, tavanlı tür var mı.
export const getLeaveAccrualContext = () => api.get('/v1/leave-variations/accrual-context');
